module.exports = ioredis;